import * as React from 'react'
import classNames from 'classnames'
import { IconDefinition } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { StepStatus } from './model'

interface StepProps {
  status: StepStatus
  dataQa: string
  icon: IconDefinition
  title: string
  label: string
}

export const Step: React.FC<StepProps> = (p) => (
  <div data-qa={p.dataQa} className={classNames('step', statusClass[p.status])}>
    <div className="step-bar">
      <div className="step-circle">
        <FontAwesomeIcon icon={p.icon} />
      </div>
    </div>
    <div className="step-title">{p.title}</div>
    <div className="step-label">{p.label}</div>
  </div>
)

const statusClass: Record<StepStatus, string> = {
  NOT_STARTED: 'not-started',
  PENDING: 'pending',
  ACTIVE: 'active',
  COMPLETED: 'completed',
  DISABLED: 'disabled'
}
